"use client";

import { useEffect } from "react";
import "./_app_link.scss";
import { getAssetImage } from "@/service/image/asset";
import { CookiesSetup } from "@/utility-components/cookies-setup/cookies-setup";

export default function Index() {
  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;

    if (iOS()) {
      window.location.href =
        "https://apps.apple.com/pl/app/remedium/id1666340112?l=pl";
    } else if (isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=md.remedium.app";
    }
  }, []);

  return (
    <html lang="pl">
      <head></head>
      <body>
        <div className="app-link" id="download">
          <div style={{ textAlign: "center", marginBottom: "4rem" }}>
            <a href="/public">
              <img
                src={getAssetImage("/logo.svg")}
                alt="remedium logo"
                className={"mx-auto hidden xl:block"}
                style={{ width: "160px" }}
              />
            </a>
          </div>

          <div className="app-link__desc">Pobierz aplikację już teraz</div>
          <div className="app-link__icons">
            <a
              className="app-link__google app-link__google--pl"
              target="_blank"
              rel="noreferrer nofollow noopener"
              href="https://play.google.com/store/apps/details?id=md.remedium.app"
            >
              <img src={getAssetImage("/app_link/google.png")} alt="google" />
            </a>
            <a
              className="app-link__apple"
              target="_blank"
              rel="noreferrer nofollow noopener"
              href="https://apps.apple.com/pl/app/remedium/id1666340112?l=pl"
            >
              <img src={getAssetImage("/app_link/apple.svg")} alt="apple" />
            </a>
          </div>
        </div>
        <CookiesSetup />
      </body>
    </html>
  );
}
